'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omitBy2 = require('lodash/omitBy');

var _omitBy3 = _interopRequireDefault(_omitBy2);

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _isNil2 = require('lodash/isNil');

var _isNil3 = _interopRequireDefault(_isNil2);

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _cloneDeep2 = require('lodash/cloneDeep');

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _reactRouter = require('react-router');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _common = require('../common');

var _CaseTrackingSidebar = require('./CaseTrackingSidebar');

var _CaseTrackingSidebar2 = _interopRequireDefault(_CaseTrackingSidebar);

var _CaseTrackingList = require('./CaseTrackingList');

var _CaseTrackingList2 = _interopRequireDefault(_CaseTrackingList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CaseTrackingPage = (_dec = (0, _mobxReact.inject)('SessionStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(CaseTrackingPage, _Component);

  function CaseTrackingPage(props) {
    _classCallCheck(this, CaseTrackingPage);

    var _this = _possibleConstructorReturn(this, (CaseTrackingPage.__proto__ || Object.getPrototypeOf(CaseTrackingPage)).call(this, props));

    _this.searchString = 'INITIAL';
    var UiStore = props.UiStore,
        location = _reactRouter.browserHistory.getCurrentLocation(),
        hasQuery = !!Object.keys(location.query).length;


    UiStore.caseTrackingPage.forceFetch = true;

    if (!hasQuery) {
      // set status from store or default
      _this.onFilterChange({});
      return _possibleConstructorReturn(_this);
    }

    _this.setStateFromProps(_this.props);
    return _this;
  }

  _createClass(CaseTrackingPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          SessionStore = _props.SessionStore,
          filters = _props.UiStore.caseTrackingPage.filters;


      SessionStore.trackEvent('CASE_TRACKING_LIST_MOUNTED', { filters: filters });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setStateFromProps(nextProps);
    }
  }, {
    key: 'setStateFromProps',
    value: function setStateFromProps(props) {
      var UiStore = this.props.UiStore,
          _browserHistory$getCu = _reactRouter.browserHistory.getCurrentLocation(),
          search = _browserHistory$getCu.search,
          query = _browserHistory$getCu.query;

      // Only reload query if search string has changed
      if (search === this.searchString) {
        return;
      }

      var newQuery = (0, _cloneDeep3.default)(query);
      Object.keys(newQuery).forEach(function (key) {
        if (newQuery[key] && !(0, _isArray3.default)(newQuery[key])) {
          newQuery[key] = [newQuery[key]];
        }
      });

      UiStore.caseTrackingPage.filters = newQuery;
      this.searchString = search;
    }
  }, {
    key: 'onResetAll',
    value: function onResetAll() {
      var _browserHistory$getCu2 = _reactRouter.browserHistory.getCurrentLocation(),
          pathname = _browserHistory$getCu2.pathname,
          _props2 = this.props,
          SessionStore = _props2.SessionStore,
          caseTrackingPage = _props2.UiStore.caseTrackingPage;

      SessionStore.trackEvent('CASE_TRACKING_PAGE_RESET_ALL');

      caseTrackingPage.filters = {};
      caseTrackingPage.ordering = [];
      _reactRouter.browserHistory.push({ pathname: pathname, query: {} });
    }
  }, {
    key: 'onFilterChange',
    value: function onFilterChange(changes) {
      var _props3 = this.props,
          SessionStore = _props3.SessionStore,
          UiStore = _props3.UiStore,
          _browserHistory$getCu3 = _reactRouter.browserHistory.getCurrentLocation(),
          pathname = _browserHistory$getCu3.pathname;

      var query = (0, _omit3.default)(UiStore.caseTrackingPage.query, ['ordering']);

      if (Object.keys(changes).length) {
        SessionStore.trackEvent('CASE_TRACKING_LIST_FILTER_CHANGE', { changes: changes });
      }

      if (changes.lawfirm) {
        query = (0, _omit3.default)(query, ['attorney', 'tracking_contact']);
      }

      query = _extends({}, query, changes);
      query = (0, _omitBy3.default)(query, _isNil3.default);
      _reactRouter.browserHistory.push({ pathname: pathname, query: query });
    }
  }, {
    key: 'renderPageSidebar',
    value: function renderPageSidebar(isMightyFreeUser) {
      if (isMightyFreeUser) {
        return null;
      }

      return _react2.default.createElement(
        _common.Page.Sidebar,
        null,
        _react2.default.createElement(_CaseTrackingSidebar2.default, { onFilterChange: this.onFilterChange, onResetAll: this.onResetAll })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var helmetTag = _react2.default.createElement(_reactHelmet2.default, { title: 'Case Tracking' }),
          isMightyFreeUser = this.props.SessionStore.isMightyFreeUser;


      return _react2.default.createElement(
        _common.Page,
        { name: 'case-tracking', hasSidebar: !isMightyFreeUser, type: 'list' },
        helmetTag,
        this.renderPageSidebar(isMightyFreeUser),
        _react2.default.createElement(
          _common.Page.Content,
          null,
          _react2.default.createElement(_CaseTrackingList2.default, {
            onFilterChange: this.onFilterChange,
            searchString: this.searchString
          })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return CaseTrackingPage;
}(_react.Component), _class2.propTypes = {
  SessionStore: _propTypes2.default.object,
  UiStore: _propTypes2.default.object
}, _temp)) || _class) || _class) || _class);
var _default = CaseTrackingPage;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CaseTrackingPage, 'CaseTrackingPage', '/app/src/components/page-case-tracking/CaseTrackingPage.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case-tracking/CaseTrackingPage.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL3BhZ2UtY2FzZS10cmFja2luZy9DYXNlVHJhY2tpbmdQYWdlLmpzIl0sIm5hbWVzIjpbIkNhc2VUcmFja2luZ1BhZ2UiLCJhdXRvQmluZE1ldGhvZHMiLCJvYnNlcnZlciIsInByb3BzIiwic2VhcmNoU3RyaW5nIiwiVWlTdG9yZSIsImxvY2F0aW9uIiwiYnJvd3Nlckhpc3RvcnkiLCJnZXRDdXJyZW50TG9jYXRpb24iLCJoYXNRdWVyeSIsIk9iamVjdCIsImtleXMiLCJxdWVyeSIsImxlbmd0aCIsImNhc2VUcmFja2luZ1BhZ2UiLCJmb3JjZUZldGNoIiwib25GaWx0ZXJDaGFuZ2UiLCJzZXRTdGF0ZUZyb21Qcm9wcyIsIlNlc3Npb25TdG9yZSIsImZpbHRlcnMiLCJ0cmFja0V2ZW50IiwibmV4dFByb3BzIiwic2VhcmNoIiwibmV3UXVlcnkiLCJmb3JFYWNoIiwia2V5IiwicGF0aG5hbWUiLCJvcmRlcmluZyIsInB1c2giLCJjaGFuZ2VzIiwibGF3ZmlybSIsImlzTWlnaHR5RnJlZVVzZXIiLCJvblJlc2V0QWxsIiwiaGVsbWV0VGFnIiwicmVuZGVyUGFnZVNpZGViYXIiLCJDb21wb25lbnQiLCJwcm9wVHlwZXMiLCJQcm9wVHlwZXMiLCJvYmplY3QiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOztBQUNBOztBQUNBOzs7O0FBQ0E7Ozs7QUFHQTs7QUFFQTs7OztBQUNBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUFLTUEsZ0IsV0FITCx1QkFBTyxjQUFQLEVBQXVCLFNBQXZCLEMsb0JBQ0FDLGdDLGVBQ0FDLG1COzs7QUFJQyw0QkFBYUMsS0FBYixFQUFvQjtBQUFBOztBQUFBLG9JQUNaQSxLQURZOztBQUFBLFVBRnBCQyxZQUVvQixHQUZMLFNBRUs7QUFHWixRQUFFQyxPQUFGLEdBQWNGLEtBQWQsQ0FBRUUsT0FBRjtBQUFBLFFBQ0ZDLFFBREUsR0FDU0MsNEJBQWVDLGtCQUFmLEVBRFQ7QUFBQSxRQUVGQyxRQUZFLEdBRVMsQ0FBQyxDQUFDQyxPQUFPQyxJQUFQLENBQVlMLFNBQVNNLEtBQXJCLEVBQTRCQyxNQUZ2Qzs7O0FBSU5SLFlBQVFTLGdCQUFSLENBQXlCQyxVQUF6QixHQUFzQyxJQUF0Qzs7QUFFQSxRQUFJLENBQUNOLFFBQUwsRUFBZTtBQUNiO0FBQ0EsWUFBS08sY0FBTCxDQUFvQixFQUFwQjtBQUNBO0FBQ0Q7O0FBRUQsVUFBS0MsaUJBQUwsQ0FBdUIsTUFBS2QsS0FBNUI7QUFma0I7QUFnQm5COzs7O3dDQUVvQjtBQUFBLG1CQUNrRCxLQUFLQSxLQUR2RDtBQUFBLFVBQ1hlLFlBRFcsVUFDWEEsWUFEVztBQUFBLFVBQ2tDQyxPQURsQyxVQUNHZCxPQURILENBQ2NTLGdCQURkLENBQ2tDSyxPQURsQzs7O0FBR25CRCxtQkFBYUUsVUFBYixDQUF3Qiw0QkFBeEIsRUFBc0QsRUFBRUQsZ0JBQUYsRUFBdEQ7QUFDRDs7OzhDQUUwQkUsUyxFQUFXO0FBQ3BDLFdBQUtKLGlCQUFMLENBQXVCSSxTQUF2QjtBQUNEOzs7c0NBRWtCbEIsSyxFQUFPO0FBQ2xCLFVBQUVFLE9BQUYsR0FBYyxLQUFLRixLQUFuQixDQUFFRSxPQUFGO0FBQUEsa0NBQ2tCRSw0QkFBZUMsa0JBQWYsRUFEbEI7QUFBQSxVQUNBYyxNQURBLHlCQUNBQSxNQURBO0FBQUEsVUFDUVYsS0FEUix5QkFDUUEsS0FEUjs7QUFHTjtBQUNBLFVBQUlVLFdBQVcsS0FBS2xCLFlBQXBCLEVBQWtDO0FBQ2hDO0FBQ0Q7O0FBRUQsVUFBTW1CLFdBQVcseUJBQVVYLEtBQVYsQ0FBakI7QUFDQUYsYUFBT0MsSUFBUCxDQUFZWSxRQUFaLEVBQXNCQyxPQUF0QixDQUE4QixlQUFPO0FBQ25DLFlBQUlELFNBQVNFLEdBQVQsS0FBaUIsQ0FBQyx1QkFBUUYsU0FBU0UsR0FBVCxDQUFSLENBQXRCLEVBQThDO0FBQzVDRixtQkFBU0UsR0FBVCxJQUFnQixDQUFDRixTQUFTRSxHQUFULENBQUQsQ0FBaEI7QUFDRDtBQUNGLE9BSkQ7O0FBTUFwQixjQUFRUyxnQkFBUixDQUF5QkssT0FBekIsR0FBbUNJLFFBQW5DO0FBQ0EsV0FBS25CLFlBQUwsR0FBb0JrQixNQUFwQjtBQUNEOzs7aUNBRWE7QUFBQSxtQ0FDU2YsNEJBQWVDLGtCQUFmLEVBRFQ7QUFBQSxVQUNKa0IsUUFESSwwQkFDSkEsUUFESTtBQUFBLG9CQUUwQyxLQUFLdkIsS0FGL0M7QUFBQSxVQUVOZSxZQUZNLFdBRU5BLFlBRk07QUFBQSxVQUVtQkosZ0JBRm5CLFdBRVFULE9BRlIsQ0FFbUJTLGdCQUZuQjs7QUFLWkksbUJBQWFFLFVBQWIsQ0FBd0IsOEJBQXhCOztBQUVBTix1QkFBaUJLLE9BQWpCLEdBQTJCLEVBQTNCO0FBQ0FMLHVCQUFpQmEsUUFBakIsR0FBNEIsRUFBNUI7QUFDQXBCLGtDQUFlcUIsSUFBZixDQUFvQixFQUFFRixrQkFBRixFQUFZZCxPQUFPLEVBQW5CLEVBQXBCO0FBQ0Q7OzttQ0FFZWlCLE8sRUFBUztBQUFBLG9CQUNXLEtBQUsxQixLQURoQjtBQUFBLFVBQ2ZlLFlBRGUsV0FDZkEsWUFEZTtBQUFBLFVBQ0RiLE9BREMsV0FDREEsT0FEQztBQUFBLG1DQUVKRSw0QkFBZUMsa0JBQWYsRUFGSTtBQUFBLFVBRWpCa0IsUUFGaUIsMEJBRWpCQSxRQUZpQjs7QUFJdkIsVUFBSWQsUUFBUSxvQkFBS1AsUUFBUVMsZ0JBQVIsQ0FBeUJGLEtBQTlCLEVBQXFDLENBQUMsVUFBRCxDQUFyQyxDQUFaOztBQUVBLFVBQUlGLE9BQU9DLElBQVAsQ0FBWWtCLE9BQVosRUFBcUJoQixNQUF6QixFQUFpQztBQUMvQksscUJBQWFFLFVBQWIsQ0FBd0Isa0NBQXhCLEVBQTRELEVBQUNTLGdCQUFELEVBQTVEO0FBQ0Q7O0FBRUQsVUFBSUEsUUFBUUMsT0FBWixFQUFxQjtBQUNuQmxCLGdCQUFRLG9CQUFLQSxLQUFMLEVBQVksQ0FBQyxVQUFELEVBQWEsa0JBQWIsQ0FBWixDQUFSO0FBQ0Q7O0FBRURBLDJCQUFhQSxLQUFiLEVBQXVCaUIsT0FBdkI7QUFDQWpCLGNBQVEsc0JBQU9BLEtBQVAsa0JBQVI7QUFDQUwsa0NBQWVxQixJQUFmLENBQW9CLEVBQUVGLGtCQUFGLEVBQVlkLFlBQVosRUFBcEI7QUFDRDs7O3NDQUVrQm1CLGdCLEVBQWtCO0FBQ25DLFVBQUlBLGdCQUFKLEVBQXNCO0FBQ3BCLGVBQU8sSUFBUDtBQUNEOztBQUVELGFBQ0U7QUFBQyxvQkFBRCxDQUFNLE9BQU47QUFBQTtBQUNFLHNDQUFDLDZCQUFELElBQXFCLGdCQUFnQixLQUFLZixjQUExQyxFQUEwRCxZQUFZLEtBQUtnQixVQUEzRTtBQURGLE9BREY7QUFLRDs7OzZCQUVTO0FBQ0Ysc0JBQWEsOEJBQUMscUJBQUQsSUFBUSxPQUFNLGVBQWQsR0FBYjtBQUFBLFVBQ0FELGdCQURBLEdBQ3FCLEtBQUs1QixLQUFMLENBQVdlLFlBRGhDLENBQ0FhLGdCQURBOzs7QUFHTixhQUNFO0FBQUMsb0JBQUQ7QUFBQSxVQUFNLE1BQUssZUFBWCxFQUEyQixZQUFZLENBQUNBLGdCQUF4QyxFQUEwRCxNQUFLLE1BQS9EO0FBQ0dFLGlCQURIO0FBRUcsYUFBS0MsaUJBQUwsQ0FBdUJILGdCQUF2QixDQUZIO0FBR0U7QUFBQyxzQkFBRCxDQUFNLE9BQU47QUFBQTtBQUNFLHdDQUFDLDBCQUFEO0FBQ0UsNEJBQWdCLEtBQUtmLGNBRHZCO0FBRUUsMEJBQWMsS0FBS1o7QUFGckI7QUFERjtBQUhGLE9BREY7QUFZRDs7Ozs7Ozs7Ozs7RUE5RzRCK0IsZ0IsV0FnSHRCQyxTLEdBQVk7QUFDakJsQixnQkFBY21CLG9CQUFVQyxNQURQO0FBRWpCakMsV0FBU2dDLG9CQUFVQztBQUZGLEM7ZUFNTnRDLGdCOzs7Ozs7Ozs7OzswQkF0SFRBLGdCIiwiZmlsZSI6IkNhc2VUcmFja2luZ1BhZ2UuanMiLCJzb3VyY2VSb290IjoiL2FwcCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBDb21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0IHsgaW5qZWN0LCBvYnNlcnZlciB9IGZyb20gJ21vYngtcmVhY3QnO1xuaW1wb3J0IHsgYnJvd3Nlckhpc3RvcnkgfSBmcm9tICdyZWFjdC1yb3V0ZXInO1xuaW1wb3J0IGF1dG9CaW5kTWV0aG9kcyBmcm9tICdjbGFzcy1hdXRvYmluZC1kZWNvcmF0b3InO1xuaW1wb3J0IEhlbG1ldCBmcm9tICdyZWFjdC1oZWxtZXQnO1xuaW1wb3J0IHsgY2xvbmVEZWVwLCBpc0FycmF5LCBpc05pbCwgb21pdCwgb21pdEJ5IH0gZnJvbSAnbG9kYXNoJztcblxuaW1wb3J0IHsgUGFnZSB9IGZyb20gJy4uL2NvbW1vbic7XG5cbmltcG9ydCBDYXNlVHJhY2tpbmdTaWRlYmFyIGZyb20gJy4vQ2FzZVRyYWNraW5nU2lkZWJhcic7XG5pbXBvcnQgQ2FzZVRyYWNraW5nTGlzdCBmcm9tICcuL0Nhc2VUcmFja2luZ0xpc3QnO1xuXG5AaW5qZWN0KCdTZXNzaW9uU3RvcmUnLCAnVWlTdG9yZScpXG5AYXV0b0JpbmRNZXRob2RzXG5Ab2JzZXJ2ZXJcbmNsYXNzIENhc2VUcmFja2luZ1BhZ2UgZXh0ZW5kcyBDb21wb25lbnQge1xuICBzZWFyY2hTdHJpbmcgPSAnSU5JVElBTCc7XG5cbiAgY29uc3RydWN0b3IgKHByb3BzKSB7XG4gICAgc3VwZXIocHJvcHMpO1xuXG4gICAgY29uc3QgeyBVaVN0b3JlIH0gPSBwcm9wc1xuICAgICAgLCBsb2NhdGlvbiA9IGJyb3dzZXJIaXN0b3J5LmdldEN1cnJlbnRMb2NhdGlvbigpXG4gICAgICAsIGhhc1F1ZXJ5ID0gISFPYmplY3Qua2V5cyhsb2NhdGlvbi5xdWVyeSkubGVuZ3RoO1xuXG4gICAgVWlTdG9yZS5jYXNlVHJhY2tpbmdQYWdlLmZvcmNlRmV0Y2ggPSB0cnVlO1xuXG4gICAgaWYgKCFoYXNRdWVyeSkge1xuICAgICAgLy8gc2V0IHN0YXR1cyBmcm9tIHN0b3JlIG9yIGRlZmF1bHRcbiAgICAgIHRoaXMub25GaWx0ZXJDaGFuZ2Uoe30pO1xuICAgICAgcmV0dXJuO1xuICAgIH1cblxuICAgIHRoaXMuc2V0U3RhdGVGcm9tUHJvcHModGhpcy5wcm9wcyk7XG4gIH1cblxuICBjb21wb25lbnREaWRNb3VudCAoKSB7XG4gICAgY29uc3QgeyBTZXNzaW9uU3RvcmUsIFVpU3RvcmU6IHsgY2FzZVRyYWNraW5nUGFnZTogeyBmaWx0ZXJzIH0gfSB9ID0gdGhpcy5wcm9wcztcblxuICAgIFNlc3Npb25TdG9yZS50cmFja0V2ZW50KCdDQVNFX1RSQUNLSU5HX0xJU1RfTU9VTlRFRCcsIHsgZmlsdGVycyB9KTtcbiAgfVxuXG4gIGNvbXBvbmVudFdpbGxSZWNlaXZlUHJvcHMgKG5leHRQcm9wcykge1xuICAgIHRoaXMuc2V0U3RhdGVGcm9tUHJvcHMobmV4dFByb3BzKTtcbiAgfVxuXG4gIHNldFN0YXRlRnJvbVByb3BzIChwcm9wcykge1xuICAgIGNvbnN0IHsgVWlTdG9yZSB9ID0gdGhpcy5wcm9wc1xuICAgICAgLCB7IHNlYXJjaCwgcXVlcnkgfSA9IGJyb3dzZXJIaXN0b3J5LmdldEN1cnJlbnRMb2NhdGlvbigpO1xuXG4gICAgLy8gT25seSByZWxvYWQgcXVlcnkgaWYgc2VhcmNoIHN0cmluZyBoYXMgY2hhbmdlZFxuICAgIGlmIChzZWFyY2ggPT09IHRoaXMuc2VhcmNoU3RyaW5nKSB7XG4gICAgICByZXR1cm47XG4gICAgfVxuXG4gICAgY29uc3QgbmV3UXVlcnkgPSBjbG9uZURlZXAocXVlcnkpO1xuICAgIE9iamVjdC5rZXlzKG5ld1F1ZXJ5KS5mb3JFYWNoKGtleSA9PiB7XG4gICAgICBpZiAobmV3UXVlcnlba2V5XSAmJiAhaXNBcnJheShuZXdRdWVyeVtrZXldKSkge1xuICAgICAgICBuZXdRdWVyeVtrZXldID0gW25ld1F1ZXJ5W2tleV1dO1xuICAgICAgfVxuICAgIH0pO1xuXG4gICAgVWlTdG9yZS5jYXNlVHJhY2tpbmdQYWdlLmZpbHRlcnMgPSBuZXdRdWVyeTtcbiAgICB0aGlzLnNlYXJjaFN0cmluZyA9IHNlYXJjaDtcbiAgfVxuXG4gIG9uUmVzZXRBbGwgKCkge1xuICAgIGNvbnN0IHsgcGF0aG5hbWUgfSA9IGJyb3dzZXJIaXN0b3J5LmdldEN1cnJlbnRMb2NhdGlvbigpXG4gICAgICAsIHsgU2Vzc2lvblN0b3JlLCBVaVN0b3JlOiB7IGNhc2VUcmFja2luZ1BhZ2UgfSB9ID0gdGhpcy5wcm9wc1xuICAgICAgO1xuXG4gICAgU2Vzc2lvblN0b3JlLnRyYWNrRXZlbnQoJ0NBU0VfVFJBQ0tJTkdfUEFHRV9SRVNFVF9BTEwnKTtcblxuICAgIGNhc2VUcmFja2luZ1BhZ2UuZmlsdGVycyA9IHt9O1xuICAgIGNhc2VUcmFja2luZ1BhZ2Uub3JkZXJpbmcgPSBbXTtcbiAgICBicm93c2VySGlzdG9yeS5wdXNoKHsgcGF0aG5hbWUsIHF1ZXJ5OiB7fSB9KTtcbiAgfVxuXG4gIG9uRmlsdGVyQ2hhbmdlIChjaGFuZ2VzKSB7XG4gICAgY29uc3QgeyBTZXNzaW9uU3RvcmUsIFVpU3RvcmUgfSA9IHRoaXMucHJvcHNcbiAgICAgICwgeyBwYXRobmFtZSB9ID0gYnJvd3Nlckhpc3RvcnkuZ2V0Q3VycmVudExvY2F0aW9uKCk7XG5cbiAgICBsZXQgcXVlcnkgPSBvbWl0KFVpU3RvcmUuY2FzZVRyYWNraW5nUGFnZS5xdWVyeSwgWydvcmRlcmluZyddKTtcblxuICAgIGlmIChPYmplY3Qua2V5cyhjaGFuZ2VzKS5sZW5ndGgpIHtcbiAgICAgIFNlc3Npb25TdG9yZS50cmFja0V2ZW50KCdDQVNFX1RSQUNLSU5HX0xJU1RfRklMVEVSX0NIQU5HRScsIHtjaGFuZ2VzfSk7XG4gICAgfVxuXG4gICAgaWYgKGNoYW5nZXMubGF3ZmlybSkge1xuICAgICAgcXVlcnkgPSBvbWl0KHF1ZXJ5LCBbJ2F0dG9ybmV5JywgJ3RyYWNraW5nX2NvbnRhY3QnXSk7XG4gICAgfVxuXG4gICAgcXVlcnkgPSB7IC4uLnF1ZXJ5LCAuLi5jaGFuZ2VzIH07XG4gICAgcXVlcnkgPSBvbWl0QnkocXVlcnksIGlzTmlsKTtcbiAgICBicm93c2VySGlzdG9yeS5wdXNoKHsgcGF0aG5hbWUsIHF1ZXJ5IH0pO1xuICB9XG5cbiAgcmVuZGVyUGFnZVNpZGViYXIgKGlzTWlnaHR5RnJlZVVzZXIpIHtcbiAgICBpZiAoaXNNaWdodHlGcmVlVXNlcikge1xuICAgICAgcmV0dXJuIG51bGw7XG4gICAgfVxuXG4gICAgcmV0dXJuIChcbiAgICAgIDxQYWdlLlNpZGViYXI+XG4gICAgICAgIDxDYXNlVHJhY2tpbmdTaWRlYmFyIG9uRmlsdGVyQ2hhbmdlPXt0aGlzLm9uRmlsdGVyQ2hhbmdlfSBvblJlc2V0QWxsPXt0aGlzLm9uUmVzZXRBbGx9IC8+XG4gICAgICA8L1BhZ2UuU2lkZWJhcj5cbiAgICApO1xuICB9XG5cbiAgcmVuZGVyICgpIHtcbiAgICBjb25zdCBoZWxtZXRUYWcgPSAoPEhlbG1ldCB0aXRsZT0nQ2FzZSBUcmFja2luZycgLz4pXG4gICAgICAsIHsgaXNNaWdodHlGcmVlVXNlciB9ID0gdGhpcy5wcm9wcy5TZXNzaW9uU3RvcmU7XG5cbiAgICByZXR1cm4gKFxuICAgICAgPFBhZ2UgbmFtZT0nY2FzZS10cmFja2luZycgaGFzU2lkZWJhcj17IWlzTWlnaHR5RnJlZVVzZXJ9IHR5cGU9J2xpc3QnPlxuICAgICAgICB7aGVsbWV0VGFnfVxuICAgICAgICB7dGhpcy5yZW5kZXJQYWdlU2lkZWJhcihpc01pZ2h0eUZyZWVVc2VyKX1cbiAgICAgICAgPFBhZ2UuQ29udGVudD5cbiAgICAgICAgICA8Q2FzZVRyYWNraW5nTGlzdFxuICAgICAgICAgICAgb25GaWx0ZXJDaGFuZ2U9e3RoaXMub25GaWx0ZXJDaGFuZ2V9XG4gICAgICAgICAgICBzZWFyY2hTdHJpbmc9e3RoaXMuc2VhcmNoU3RyaW5nfVxuICAgICAgICAgIC8+XG4gICAgICAgIDwvUGFnZS5Db250ZW50PlxuICAgICAgPC9QYWdlPlxuICAgICk7XG4gIH1cblxuICBzdGF0aWMgcHJvcFR5cGVzID0ge1xuICAgIFNlc3Npb25TdG9yZTogUHJvcFR5cGVzLm9iamVjdCxcbiAgICBVaVN0b3JlOiBQcm9wVHlwZXMub2JqZWN0LFxuICB9XG59XG5cbmV4cG9ydCBkZWZhdWx0IENhc2VUcmFja2luZ1BhZ2U7XG4iXX0=